export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtSMVaria';
export const NAME = 'ZakazkaZarazeni';
